import { Action } from '@ngrx/store';
import { OrderModel, RequestTemplateDTO, RequestActDTO, StatusDTO, OrdersForNotification } from './model';

export enum ActionTypes {
  FAILURE = '[Order] Failure',

  LOAD_REQUEST = '[Order] Load Request',
  LOAD_SUCCESS = '[Order] Load Success',

  LOAD_BY_ID_REQUEST = '[Order] Load by ID Request',
  LOAD_BY_ID_SUCCESS = '[Order] Load by ID Success',

  SET_FILTERTYPE_REQUEST = '[Order] Set FilterType Request',

  SET_SELECTED_REQUEST = '[Order] Set Selected Request',
  SET_SELECTED_SUCCESS = '[Order] Set Selected Success',

  SET_SELECTED_EMPLOYEE_ID_REQUEST = '[Order] Set Selected Employee Id Request',
  SET_SELECTED_EMPLOYEE_ID_SUCCESS = '[Order] Set Selected Employee Id Success',

  CREATE_REQUEST = '[Order] Create Request',
  CREATE_SUCCESS = '[Order] Create Success',

  SAVE_REQUEST = '[Order] Save Request',
  SAVE_SUCCESS = '[Order] Save Success',

  LOAD_TEMPLATE_REQUEST = '[Order] Load Template Request',
  LOAD_TEMPLATE_SUCCESS = '[Order] Load Template Success',

  SAVE_STATUS_REQUEST = '[Order] Save Status Request',
  SAVE_STATUS_SUCCESS = '[Order] Save Status Success',

  CLEAR_SELECTED_REQUEST = '[Order] Clear Selected Request',

  LOAD_ACTS_REQUEST = '[Order] Load Acts Request',
  LOAD_ACTS_SUCCESS = '[Order] Load Acts Success',

  LOAD_ALLOWED_STATUSES_REQUEST = '[Order] Load Allowed Statuses Request',
  LOAD_ALLOWED_STATUSES_SUCCESS = '[Order] Load Allowed Statuses Success',

  CREATE_ACT_REQUEST = '[Order] Create Act Request',

  LOAD_FOR_NOTIFICATION_REQUEST = '[Order] Load Orders For Notification Request',
  LOAD_FOR_NOTIFICATION_SUCCESS = '[Order] Load Orders For Notification Success',
}

export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}

export class LoadRequestAction implements Action {
  readonly type = ActionTypes.LOAD_REQUEST;
  constructor(
    public userId: number,
    public fromDate: Date,
    public toDate: Date
  ) {}
}

export class LoadSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_SUCCESS;
  constructor(public items: OrderModel[]) {}
}

export class LoadByIdRequestAction implements Action {
  readonly type = ActionTypes.LOAD_BY_ID_REQUEST;
  constructor(
    public orderId: number,
    public userId: number
  ) {}
}

export class LoadByIdSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_BY_ID_SUCCESS;
  constructor(public items: OrderModel) {}
}

export class SetFilterTypeRequestAction implements Action {
  readonly type = ActionTypes.SET_FILTERTYPE_REQUEST;
  constructor(public filterType: string) {}
}

export class SetSelectedRequestAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_REQUEST;

  constructor(
    public orderId: number,
    public userId: number
  ) {}
}

export class SetSelectedSuccessAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_SUCCESS;

  constructor(public order: OrderModel) {}
}

export class SetSelectedEmployeeIdRequestAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_EMPLOYEE_ID_REQUEST;

  constructor(public employeeId: number) {}
}

export class SetSelectedEmployeeIdSuccessAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_EMPLOYEE_ID_SUCCESS;

  constructor(public employeeId: number) {}
}

export class CreateRequestAction implements Action {
  readonly type = ActionTypes.CREATE_REQUEST;

  constructor(
    public order: OrderModel,
    public files: any[]
  ) {}
}

export class CreateSuccessAction implements Action {
  readonly type = ActionTypes.CREATE_SUCCESS;

  constructor(public order: OrderModel) {}
}

export class SaveRequestAction implements Action {
  readonly type = ActionTypes.SAVE_REQUEST;

  constructor(
    public order: OrderModel,
    public isChangedOrder: boolean,
    public userId: number,
    public files: any[]
  ) {}
}

export class SaveSuccessAction implements Action {
  readonly type = ActionTypes.SAVE_SUCCESS;

  constructor(public order: OrderModel) {}
}

export class LoadTemplateRequestAction implements Action {
  readonly type = ActionTypes.LOAD_TEMPLATE_REQUEST;

  constructor(
    public categoryId: number,
    public serviceId: number
  ) {}
}

export class LoadTemplateSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_TEMPLATE_SUCCESS;

  constructor(public template: RequestTemplateDTO) {}
}

export class SaveStatusRequestAction implements Action {
  readonly type = ActionTypes.SAVE_STATUS_REQUEST;

  constructor(
    public orderId: number,
    public mark: number,
    public userId: number,
    public comment: string,
    public files: any[],
    public newStatusId: number,
    public setSelected: boolean
  ) {}
}

export class SaveStatusSuccessAction implements Action {
  readonly type = ActionTypes.SAVE_STATUS_SUCCESS;

  constructor(
    public order: OrderModel,
    public setSelected: boolean
  ) {}
}

export class ClearSelectedRequestAction implements Action {
  readonly type = ActionTypes.CLEAR_SELECTED_REQUEST;

  constructor() {}
}

export class LoadActsRequestAction implements Action {
  readonly type = ActionTypes.LOAD_ACTS_REQUEST;

  constructor(public orderId: number) {}
}

export class LoadActsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_ACTS_SUCCESS;

  constructor(public acts: RequestActDTO[]) {}
}

export class LoadAllowedStatusesRequestAction implements Action {
  readonly type = ActionTypes.LOAD_ALLOWED_STATUSES_REQUEST;

  constructor(
    public orderId: number,
    public userId: number
  ) {}
}

export class LoadAllowedStatusesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_ALLOWED_STATUSES_SUCCESS;

  constructor(public statuses: StatusDTO[]) {}
}

export class CreateActRequestAction implements Action {
  readonly type = ActionTypes.CREATE_ACT_REQUEST;

  constructor(
    public orderId: number,
    public userId: number,
    public value: string
  ) {}
}

export class LoadForNotificationRequestAction implements Action {
  readonly type = ActionTypes.LOAD_FOR_NOTIFICATION_REQUEST;

  constructor(public userId: number) {}
}

export class LoadForNotificationSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_FOR_NOTIFICATION_SUCCESS;

  constructor(public ordersForNotification: OrdersForNotification[]) {}
}

export type Actions =
  | FailureAction
  | LoadRequestAction
  | LoadSuccessAction
  | LoadByIdRequestAction
  | LoadByIdSuccessAction
  | SetFilterTypeRequestAction
  | SetSelectedRequestAction
  | SetSelectedSuccessAction
  | SetSelectedEmployeeIdRequestAction
  | SetSelectedEmployeeIdSuccessAction
  | CreateRequestAction
  | CreateSuccessAction
  | SaveRequestAction
  | SaveSuccessAction
  | LoadTemplateRequestAction
  | LoadTemplateSuccessAction
  | SaveStatusRequestAction
  | SaveStatusSuccessAction
  | ClearSelectedRequestAction
  | LoadActsRequestAction
  | LoadActsSuccessAction
  | LoadAllowedStatusesRequestAction
  | LoadAllowedStatusesSuccessAction
  | CreateActRequestAction
  | LoadForNotificationRequestAction
  | LoadForNotificationSuccessAction;
